import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { SelectorHook } from "./types";
import { type Role } from "../types/auth.types";

export interface Auth<T = any> {
  id: number;
  ownerId: string;
  phone: string;
  stores: Array<T>;
  username: string;
  role: string | { [key in Role]?: string };
  createdDate: string;
  activeStoreNum: number;
}

const initAuth = {
  id: 0,
  ownerId: "",
  phone: "",
  stores: [],
  username: "",
  role: "",
  createdDate: "",
  activeStoreNum: 0,
};

interface AuthState {
  auth: Auth;
  setAuth: (auth: Auth) => void;
  clearAuth: () => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      auth: initAuth,
      setAuth: (auth: Auth) => {
        set((state) => ({ ...state, auth: { ...auth } }));
      },
      clearAuth: () => {
        set((state) => ({ ...state, auth: initAuth }));
      },
    }),
    {
      name: "auth",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ auth: state.auth }),
    }
  )
);

export const useAuth: SelectorHook<AuthState, "auth"> = (
  selector = (state: AuthState) => state.auth
) => useAuthStore(selector);
